import { Controller } from "@hotwired/stimulus"

// Year selector for DepozenUi::GainsByYearComponent — toggles detail panels + selected card.
export default class extends Controller {
  static targets = ["panel", "tab"]
  static values = { selected: Number }

  connect() {
    this.render()
  }

  select(event) {
    const year = Number(event.currentTarget.dataset.year)
    if (!year || year === this.selectedValue) return

    this.selectedValue = year
    this.render()
  }

  render() {
    this.panelTargets.forEach((panel) => {
      const active = Number(panel.dataset.year) === this.selectedValue
      panel.classList.toggle("d-none", !active)
      panel.toggleAttribute("hidden", !active)
    })

    this.tabTargets.forEach((tab) => {
      const active = Number(tab.dataset.year) === this.selectedValue
      tab.classList.toggle("depozen-ui-gains-by-year__year-card--selected", active)
      tab.setAttribute("aria-selected", active ? "true" : "false")
    })
  }
}
